import { z } from 'zod';
import { currencyCodeSchema, isoDateSchema, moneySchema, nonNegativeQuantitySchema, } from './common.js';
/** Imports must declare the reviewed native basis instead of relying on ERP defaults. */
export const importPriceConditionSchema = z
    .object({
    sourceSystem: z.string().trim().min(1).max(100),
    externalId: z.string().trim().min(1).max(300),
    currency: currencyCodeSchema,
    unitCode: z.string().trim().min(1).max(30),
    minQuantity: nonNegativeQuantitySchema,
    unitPrice: moneySchema.nullable(),
    priceAmountBasis: z.literal('NET'),
    priceUnitQuantity: z.literal('1'),
    amountRole: z.literal('MIN_QUANTITY'),
    sourcePriceList: z.string().trim().min(1).max(100).optional(),
    validFrom: isoDateSchema.nullish(),
    validTo: isoDateSchema.nullish(),
})
    .superRefine((value, ctx) => {
    for (const key of ['validFrom', 'validTo']) {
        const date = value[key];
        if (date) {
            const parsed = new Date(`${date}T00:00:00.000Z`);
            if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date)
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: [key],
                    message: 'priceGroups.invalidSelection',
                });
        }
    }
    if (value.validFrom && value.validTo && value.validTo < value.validFrom)
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['validTo'],
            message: 'priceGroups.invalidSelection',
        });
});
export const supplierPriceTierSchema = z.object({
    id: z.string(),
    sourceSystem: z.string(),
    sourceExternalId: z.string(),
    currency: z.string(),
    unitCode: z.string(),
    minQuantity: z.string(),
    unitPrice: z.string().nullable(),
    validFrom: isoDateSchema.nullable(),
    validTo: isoDateSchema.nullable(),
});
//# sourceMappingURL=product-price-condition.js.map